import { render, staticRenderFns } from "./EmojiSave.vue?vue&type=template&id=1661acef&"
import script from "./EmojiSave.vue?vue&type=script&lang=js&"
export * from "./EmojiSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports